import { StatusDisplay } from './components/tab/types/videoAssetsType';

// Status display helper function
export const getStatusDisplay = (status: string): StatusDisplay => {
  switch (status) {
    case 'COMPLETED':
    case 'completed':
      return { color: 'green', label: 'Completed' };
    case 'FAILED':
    case 'failed':
      return { color: 'red', label: 'Failed' };
    case 'IN_PROGRESS':
    case 'in_progress':
    case 'processing':
      return { color: 'orange', label: 'In Progress' };
    case 'CREATING':
    case 'creating':
      return { color: 'blue', label: 'Creating' };
    case 'START':
      return { color: 'default', label: 'Start' };
    case 'uploading':
      return { color: 'blue', label: 'Uploading' };
    case 'empty':
      return { color: 'default', label: 'Waiting' };
    default:
      return { color: 'default', label: 'Unknown' };
  }
};